export function accordion() {
  const toggles = document.querySelectorAll('.accordion-toggle');

  toggles.forEach((btn) => {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));

    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';

      // Close others (remove this if you want multi-open)
      document.querySelectorAll(".accordion-toggle[aria-expanded='true']").forEach((other) => {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          const otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          otherPanel.classList.remove('is-open');
          const otherIcon = other.querySelector('.accordion-icon');
          if (otherIcon) otherIcon.textContent = '+';
        }
      });

      // Toggle current
      btn.setAttribute('aria-expanded', String(!expanded));
      panel.classList.toggle('is-open', !expanded);

      const icon = btn.querySelector('.accordion-icon');
      if (icon) icon.textContent = expanded ? '+' : '–';
    });
  });
}
